import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Header() {
    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');
    const [isSticky, setIsSticky] = useState(false);
    const [userRole, setUserRole] = useState(localStorage.getItem('userRole'));
    const [showHeader, setShowHeader] = useState(true);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const lastScrollTop = useRef(0);

    const [openSubMenu, setOpenSubMenu] = useState(null);
    const toggleSubMenu = (menu) => {
        setOpenSubMenu(openSubMenu === menu ? null : menu);
    };


    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            if (!isMobileMenuOpen) {
                if (scrollTop > lastScrollTop.current) {
                    setShowHeader(false);
                } else {
                    setShowHeader(true);
                }
            }
            lastScrollTop.current = scrollTop <= 0 ? 0 : scrollTop;
            setIsSticky(scrollTop > 0);
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isMobileMenuOpen]);  // Dependency olarak isMobileMenuOpen ekledik


    useEffect(() => {
        const storedIsLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
        setIsLoggedIn(storedIsLoggedIn);
        setUserRole(localStorage.getItem('userRole'));
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const handleLogout = () => {
        localStorage.setItem('isLoggedIn', 'false');
        localStorage.removeItem('userRole');
        setIsLoggedIn(false);
        setUserRole(null);
        navigate('/login');
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const handleMenuItemClick = () => {
        if (isMobileMenuOpen) {
            setIsMobileMenuOpen(false);
        }
    };

    return (
        <>
            <div className={`top-header-area ${isSticky ? 'sticky' : ''} ${showHeader ? '' : 'hidden'}`}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-sm-12 text-center">
                            <div className="main-menu-wrap">
                                <div className="site-logo">
                                    <Link to="/">
                                        <img src="assets/img/logo.png" alt="Logo" />
                                    </Link>
                                </div>
                                <nav className={`main-menu ${isMobileMenuOpen ? 'open' : ''}`}>
                                    <ul>
                                        <li>
                                            <Link to="/profile" onClick={handleMenuItemClick} className={location.pathname === '/profile' ? 'active' : ''}>Profil</Link>
                                        </li>
                                        <li>
                                            <Link to="/editor" onClick={handleMenuItemClick} className={location.pathname === '/editor' ? 'active' : ''}>Editörlerin Seçimi</Link>
                                        </li>
                                        <li className="has-submenu">
                                            <Link to="/oranlar" onClick={handleMenuItemClick} className={location.pathname.startsWith('/oranlar') ? 'active' : ''}>
                                                Oranlar <i className="fas fa-angle-down"></i>
                                            </Link>
                                            <ul className="sub-menu">
                                                <li>
                                                    <Link to="/acilisoran" onClick={handleMenuItemClick} className={location.pathname === '/acilisoran' ? 'active' : ''}>Açılış Oranlar</Link>
                                                </li>
                                                <li>
                                                    <Link to="/kapanisoran" onClick={handleMenuItemClick} className={location.pathname === '/kapanisoran' ? 'active' : ''}>Kapanış Oranlar</Link>
                                                </li>
                                                <li>
                                                    <Link to="/yabanciacilis" onClick={handleMenuItemClick} className={location.pathname === '/yabanciacilis' ? 'active' : ''}>Yabancı Açılış</Link>
                                                </li>
                                                <li>
                                                    <Link to="/yabancikapanis" onClick={handleMenuItemClick} className={location.pathname === '/yabancikapanis' ? 'active' : ''}>Yabancı Kapanış</Link>
                                                </li>
                                                <li>
                                                    <Link to="/yerelkapanis" onClick={handleMenuItemClick} className={location.pathname === '/yerelkapanis' ? 'active' : ''}>Yerel Kapanış</Link>
                                                </li>
                                                {/* <li>
    <Link to="/kazananlar" onClick={handleMenuItemClick} className={location.pathname === '/kazananlar' ? 'active' : ''}>Kazananlar Kulübü</Link>
</li> */}
                                            </ul>
                                        </li>
                                        {(userRole === 'editor' || userRole === 'admin' || userRole === 'user' || userRole === 'wait') && (
                                            <li className="has-submenu">
                                                <Link to="/reytingler" onClick={handleMenuItemClick} className={location.pathname.startsWith('/reytingler') ? 'active' : ''}>
                                                    Reyting <i className="fas fa-angle-down"></i>
                                                </Link>
                                                <ul className="sub-menu">
                                                    <li>
                                                        <Link to="/acilisreyting" onClick={handleMenuItemClick} className={location.pathname === '/acilisreyting' ? 'active' : ''}>Açılış Reyting</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/kapanisreyting" onClick={handleMenuItemClick} className={location.pathname === '/kapanisreyting' ? 'active' : ''}>Kapanış Reyting</Link>
                                                    </li>
                                                </ul>
                                            </li>
                                        )}

                                        {(userRole === 'admin' || userRole === 'editor') ? (
                                            <li className="has-submenu">
                                                <Link to="/acilisanaliz" onClick={handleMenuItemClick} className={['/acilisanaliz', '/zetaanaliz', '/nexoraanaliz'].includes(location.pathname) ? 'active' : ''}>
                                                    Analiz <i className="fas fa-angle-down"></i>
                                                </Link>
                                                <ul className="sub-menu">
                                                    <li><Link to="/acilisanaliz" onClick={handleMenuItemClick} className={location.pathname === '/acilisanaliz' ? 'active' : ''}>Açılış Analiz</Link></li>
                                                    <li><Link to="/zetaanaliz" onClick={handleMenuItemClick} className={location.pathname === '/zetaanaliz' ? 'active' : ''}>Zeta Analiz</Link></li>
                                                    <li><Link to="/nexoraanaliz" onClick={handleMenuItemClick} className={location.pathname === '/nexoraanaliz' ? 'active' : ''}>Nexora Analiz</Link></li>
                                                </ul>
                                            </li>
                                        ) : userRole === 'user' ? (
                                            <li className="has-submenu">
                                                <Link to="/acilisanaliz" onClick={handleMenuItemClick} className={['/acilisanaliz', '/zetaanaliz', '/nexoraanaliz'].includes(location.pathname) ? 'active' : ''}>
                                                    Analiz <i className="fas fa-angle-down"></i>
                                                </Link>
                                                <ul className="sub-menu">
                                                    <li><Link to="/acilisanaliz" onClick={handleMenuItemClick} className={location.pathname === '/acilisanaliz' ? 'active' : ''}>Açılış Analiz</Link></li>
                                                    <li><Link to="/zetaanaliz" onClick={handleMenuItemClick} className={location.pathname === '/zetaanaliz' ? 'active' : ''}>Zeta Analiz</Link></li>
                                                    <li><Link to="/nexoraanaliz" onClick={handleMenuItemClick} className={location.pathname === '/nexoraanaliz' ? 'active' : ''}>Nexora Analiz</Link></li>
                                                </ul>
                                            </li>
                                        ) : null}

                                        <li>
                                            <Link to="/urunler" onClick={handleMenuItemClick} className={location.pathname === '/urunler' ? 'active' : ''}>Ürünler</Link>
                                        </li>

                                        {(userRole === 'admin' || userRole === 'editor') && (
                                            <li className="has-submenu">
                                                <Link to="/yonetim" onClick={handleMenuItemClick} className={location.pathname.startsWith('/yonetim') ? 'active' : ''}>
                                                    Yönetim <i className="fas fa-angle-down"></i>
                                                </Link>
                                                <ul className="sub-menu">
                                                    {userRole === 'admin' && (
                                                        <li>
                                                            <Link to="/admin" onClick={handleMenuItemClick} className={location.pathname === '/admin' ? 'active' : ''}>Admin Panel</Link>
                                                        </li>
                                                    )}
                                                    {(userRole === 'admin' || userRole === 'editor') && (
                                                        <li>
                                                            <Link to="/editorgiris" onClick={handleMenuItemClick} className={location.pathname === '/editorgiris' ? 'active' : ''}>Editor Giriş</Link>
                                                        </li>
                                                    )}
                                                </ul>
                                            </li>
                                        )}

                                        <li>
                                            <Link to="/about" onClick={handleMenuItemClick} className={location.pathname === '/about' ? 'active' : ''}>Hakkımızda</Link>
                                        </li>
                                        <li>
                                            <Link to="/satinal" onClick={handleMenuItemClick} className={location.pathname === '/satinal' ? 'active' : ''}>Abone Ol</Link>
                                        </li>

                                        {isLoggedIn ? (
                                            <li>
                                                <button className="nav-link logout-button" onClick={handleLogout}>Çıkış Yap</button>
                                            </li>
                                        ) : (
                                            <>
                                                <li>
                                                    <Link to="/register" onClick={handleMenuItemClick} className={location.pathname === '/register' ? 'active' : ''}>Kayıt Ol</Link>
                                                </li>
                                                <li>
                                                    <Link to="/login" onClick={handleMenuItemClick} className={location.pathname === '/login' ? 'active' : ''}>Giriş Yap</Link>
                                                </li>
                                            </>
                                        )}
                                    </ul>
                                </nav>

                                <div className="header-actions">
                                    {isLoggedIn && (
                                        <a href="https://t.me/+-lynNeccs-Y5OWE0" target="_blank"
                                            rel="noopener noreferrer" className="telegram-link">
                                            <i className="fab fa-telegram"></i> Telegram Grubu
                                        </a>
                                    )}
                                </div>

                                <button className="mobile-show" onClick={toggleMobileMenu} type="button"
                                    aria-label={isMobileMenuOpen ? 'Menüyü kapat' : 'Menüyü aç'} aria-expanded={isMobileMenuOpen}>
                                    <i className={`fas fa-${isMobileMenuOpen ? 'times' : 'bars'}`}></i>
                                </button>
                                <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
                                    <ul>
                                        <li><Link to="/profile" onClick={handleMenuItemClick} className={location.pathname === '/profile' ? 'active' : ''}>Profil</Link></li>
                                        <li><Link to="/editor" onClick={handleMenuItemClick} className={location.pathname === '/editor' ? 'active' : ''}>Editörlerin Seçimi</Link></li>

                                        <li className={`has-submenu ${openSubMenu === 'oranlar' ? 'open' : ''}`}>
                                            <span onClick={() => toggleSubMenu('oranlar')} className={`submenu-toggle ${location.pathname.startsWith('/oranlar') ? 'active' : ''}`}>
                                                Oranlar <i className={`fas fa-angle-${openSubMenu === 'oranlar' ? 'up' : 'down'}`}></i>
                                            </span>

                                            <ul className="sub-menu" style={{ display: openSubMenu === 'oranlar' ? 'block' : 'none' }}>
                                                <li><Link to="/acilisoran" onClick={handleMenuItemClick} className={location.pathname === '/acilisoran' ? 'active' : ''}>Açılış Oranlar</Link></li>
                                                <li><Link to="/kapanisoran" onClick={handleMenuItemClick} className={location.pathname === '/kapanisoran' ? 'active' : ''}>Kapanış Oranlar</Link></li>
                                                <li><Link to="/yabanciacilis" onClick={handleMenuItemClick} className={location.pathname === '/yabanciacilis' ? 'active' : ''}>Yabancı Açılış</Link></li>
                                                <li><Link to="/yabancikapanis" onClick={handleMenuItemClick} className={location.pathname === '/yabancikapanis' ? 'active' : ''}>Yabancı Kapanış</Link></li>
                                                <li><Link to="/yerelkapanis" onClick={handleMenuItemClick} className={location.pathname === '/yerelkapanis' ? 'active' : ''}>Yerel Kapanış</Link></li>
                                            </ul>
                                        </li>
                                        {(userRole === 'editor' || userRole === 'admin' || userRole === 'user' || userRole === 'wait') && (

                                            <li className={`has-submenu ${openSubMenu === 'reyting' ? 'open' : ''}`}>
                                                <span onClick={() => toggleSubMenu('reyting')} className={`submenu-toggle ${location.pathname.startsWith('/reyting') ? 'active' : ''}`}>
                                                    Reyting <i className={`fas fa-angle-${openSubMenu === 'reyting' ? 'up' : 'down'}`}></i>
                                                </span>

                                                <ul className="sub-menu" style={{ display: openSubMenu === 'reyting' ? 'block' : 'none' }}>
                                                    {(userRole === 'editor' || userRole === 'admin' || userRole === 'user' || userRole === 'wait') && (
                                                        <>
                                                            <li>
                                                                <Link to="/acilisreyting" onClick={handleMenuItemClick} className={location.pathname === '/acilisreyting' ? 'active' : ''}>
                                                                    Açılış Reytingleri
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="/kapanisreyting" onClick={handleMenuItemClick} className={location.pathname === '/kapanisreyting' ? 'active' : ''}>
                                                                    Kapanış Reytingleri
                                                                </Link>
                                                            </li>
                                                        </>
                                                    )}
                                                </ul>
                                            </li>

                                        )}

                                        {(userRole === 'admin' || userRole === 'editor') ? (
                                            <li className={`has-submenu ${openSubMenu === 'tipstest' ? 'open' : ''}`}>
                                                <span onClick={() => toggleSubMenu('tipstest')} className={`submenu-toggle ${['/acilisanaliz', '/zetaanaliz', '/nexoraanaliz'].includes(location.pathname) ? 'active' : ''}`}>
                                                    Analiz <i className={`fas fa-angle-${openSubMenu === 'tipstest' ? 'up' : 'down'}`}></i>
                                                </span>
                                                <ul className="sub-menu" style={{ display: openSubMenu === 'tipstest' ? 'block' : 'none' }}>
                                                    <li><Link to="/acilisanaliz" onClick={handleMenuItemClick} className={location.pathname === '/acilisanaliz' ? 'active' : ''}>Açılış Analiz</Link></li>
                                                    <li><Link to="/zetaanaliz" onClick={handleMenuItemClick} className={location.pathname === '/zetaanaliz' ? 'active' : ''}>Zeta Analiz</Link></li>
                                                    <li><Link to="/nexoraanaliz" onClick={handleMenuItemClick} className={location.pathname === '/nexoraanaliz' ? 'active' : ''}>Nexora Analiz</Link></li>
                                                </ul>
                                            </li>
                                        ) : userRole === 'user' ? (
                                            <li className={`has-submenu ${openSubMenu === 'tipstest' ? 'open' : ''}`}>
                                                <span onClick={() => toggleSubMenu('tipstest')} className={`submenu-toggle ${['/acilisanaliz', '/zetaanaliz', '/nexoraanaliz'].includes(location.pathname) ? 'active' : ''}`}>
                                                    Analiz <i className={`fas fa-angle-${openSubMenu === 'tipstest' ? 'up' : 'down'}`}></i>
                                                </span>
                                                <ul className="sub-menu" style={{ display: openSubMenu === 'tipstest' ? 'block' : 'none' }}>
                                                    <li><Link to="/acilisanaliz" onClick={handleMenuItemClick} className={location.pathname === '/acilisanaliz' ? 'active' : ''}>Açılış Analiz</Link></li>
                                                    <li><Link to="/zetaanaliz" onClick={handleMenuItemClick} className={location.pathname === '/zetaanaliz' ? 'active' : ''}>Zeta Analiz</Link></li>
                                                    <li><Link to="/nexoraanaliz" onClick={handleMenuItemClick} className={location.pathname === '/nexoraanaliz' ? 'active' : ''}>Nexora Analiz</Link></li>
                                                </ul>
                                            </li>
                                        ) : null}

                                        {/* <li><Link to="/kazananlar" onClick={handleMenuItemClick} className={location.pathname === '/kazananlar' ? 'active' : ''}>Kazananlar Kulübü</Link></li> */}
                                        <li><Link to="/urunler" onClick={handleMenuItemClick} className={location.pathname === '/urunler' ? 'active' : ''}>Ürünler</Link></li>

                                        {(userRole === 'admin' || userRole === 'editor') && (

                                            <li className={`has-submenu ${openSubMenu === 'yonetim' ? 'open' : ''}`}>
                                                <span onClick={() => toggleSubMenu('yonetim')} className={`submenu-toggle ${location.pathname.startsWith('/yonetim') ? 'active' : ''}`}>
                                                    Yönetim <i className={`fas fa-angle-${openSubMenu === 'yonetim' ? 'up' : 'down'}`}></i>
                                                </span>

                                                <ul className="sub-menu" style={{ display: openSubMenu === 'yonetim' ? 'block' : 'none' }}>
                                                    {userRole === 'admin' && (
                                                        <li>
                                                            <Link to="/admin" onClick={handleMenuItemClick} className={location.pathname === '/admin' ? 'active' : ''}>Admin Panel</Link>
                                                        </li>
                                                    )}
                                                    {(userRole === 'admin' || userRole === 'editor') && (
                                                        <li>
                                                            <Link to="/editorgiris" onClick={handleMenuItemClick} className={location.pathname === '/editorgiris' ? 'active' : ''}>Editor Giriş</Link>
                                                        </li>
                                                    )}
                                                </ul>
                                            </li>

                                        )}


                                        <li><Link to="/about" onClick={handleMenuItemClick} className={location.pathname === '/about' ? 'active' : ''}>Hakkımızda</Link></li>
                                        {isLoggedIn && (
                                            <li>
                                                <a href="https://t.me/+-lynNeccs-Y5OWE0" target="_blank" rel="noopener noreferrer" className="telegram-link-mobile">
                                                    <i className="fab fa-telegram"></i> Telegram Grubu
                                                </a>
                                            </li>
                                        )}
                                        {isLoggedIn ? (
                                            <li><button className="nav-link logout-button" onClick={handleLogout}>Çıkış Yap</button></li>
                                        ) : null}
                                    </ul>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Header;
